export enum ApplicationType {
  HomeownerAssistant = "HomeownerAssistant",
  HomeownershipAccelerator = "HomeownershipAccelerator",
  UpgradeAccelerator = "UpgradeAccelerator",
}
